import { XMarkIcon } from "@heroicons/react/20/solid";
import type { ReactNode } from "react";

import type { EntryColor } from "~/modules/dashboard/components/TimeTrackingCalendar/entryStyles.ts";

type Props = {
	color: EntryColor;
	title: string;
	subtitle: string;
	onClose: () => void;
	children: ReactNode;
};

/** The open entry: a white card with a stripe in the type color. The month shows it in a popover, the day view in place. */
export function EntryCard({ color, title, subtitle, onClose, children }: Props) {
	return (
		<div className="relative w-full overflow-hidden rounded-lg bg-white text-left shadow-md ring-1 ring-gray-200 md:shadow-lg">
			<div className={`h-1.5 ${color.solid}`} />
			<div className="flex flex-col gap-2 px-3 pb-3 pt-2 text-sm">
				<div className="flex items-start">
					<button type="button"
							className="min-w-0 flex-1 pr-8 text-left"
							onClick={onClose}>
						<div className="break-words font-semibold leading-5">{title}</div>
						<div className="text-xs text-gray-500">{subtitle}</div>
					</button>
					<button type="button"
							aria-label="Schließen"
							className="absolute right-1 top-1 p-2 text-gray-400 hover:text-gray-700 md:right-3 md:top-3.5 md:p-0"
							onClick={onClose}>
						<XMarkIcon className="size-6 md:size-5" />
					</button>
				</div>
				{children}
			</div>
		</div>
	);
}
